import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { UserHierarchyModel } from "../../models/UserHierarchyModel";
import UserHierarchyService from "../../services/UserHierarchyService";
import UserHierarchySlice from "../slices/UserHierarchySlice";
import { RootState } from "../store";

export const Actions = UserHierarchySlice.actions;

export const fetchUserHierarchys = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(Actions.setIsUserHierarchiesFetching(true));
    const response: UserHierarchyModel[] =
      await UserHierarchyService.getUserHierarchys();
    dispatch(Actions.setUserHierarchy(response));
    dispatch(Actions.setIsUserHierarchiesFetching(false));
  };
};


export const fetchAllSbusofSbg = (
  sbg_name: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: UserHierarchyModel[] = await UserHierarchyService.GetSbusFromSbgs(sbg_name)
    dispatch(Actions.setAllSbusUnderSbg(response))
  };
};